import { SyntheticEvent, useCallback, useMemo, useState } from 'react';
import { SimpleTreeView } from '@mui/x-tree-view';
import { NavigationTreeItem as NavTreeItem } from './NavigationTreeItem';
import { ChevronRight, ExpandMore } from '@mui/icons-material';
import { TreeNode } from './NavigationTreeView';

interface Props {
  nodes: TreeNode[];
  selectedNodeIds: string[];
}

function getAllDefaultExpandedIds(nodes: TreeNode[]): string[] {
  return nodes
    .filter(({ defaultExpanded }) => defaultExpanded)
    .flatMap(({ id, childNodes }) => {
      if (childNodes?.length) {
        return getAllDefaultExpandedIds(childNodes).concat(id);
      }
      return [id];
    });
}

export function NavigationTreeViewMultiSelect({ nodes, selectedNodeIds }: Props) {
  const initialExpandedList = useMemo(() => getAllDefaultExpandedIds(nodes), [nodes]);
  const [expandedItems, setExpandedItems] = useState<string[]>(initialExpandedList);

  const handleToggle = (_event: SyntheticEvent<Element, Event> | null, itemIds: string[]) => {
    setExpandedItems(itemIds);
  };

  const isSelected = useCallback((id: string) => selectedNodeIds.includes(id), [selectedNodeIds]);

  return (
    <SimpleTreeView
      multiSelect
      checkboxSelection
      expandedItems={expandedItems}
      onExpandedItemsChange={handleToggle}
      selectedItems={selectedNodeIds}
      slots={{ collapseIcon: () => <ExpandMore color="primary" />, expandIcon: ChevronRight }}
    >
      {nodes.map((node) => (
        <NavTreeItem key={node.id} depth={0} {...node} isSelected={isSelected} includeCheckbox />
      ))}
    </SimpleTreeView>
  );
}
